/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as UitnodigingAccepterenRouteImport } from './routes/uitnodiging-accepteren'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedTransactionsRouteImport } from './routes/_authenticated/transactions'
import { Route as AuthenticatedSubscriptionsRouteImport } from './routes/_authenticated/subscriptions'
import { Route as AuthenticatedSubscriptionRouteImport } from './routes/_authenticated/subscription'
import { Route as AuthenticatedSharedCardsRouteImport } from './routes/_authenticated/shared-cards'
import { Route as AuthenticatedProfileRouteImport } from './routes/_authenticated/profile'
import { Route as AuthenticatedProductsRouteImport } from './routes/_authenticated/products'
import { Route as AuthenticatedOvCardsRouteImport } from './routes/_authenticated/ov-cards'
import { Route as AuthenticatedMessagesRouteImport } from './routes/_authenticated/messages'
import { Route as AuthenticatedImportsRouteImport } from './routes/_authenticated/imports'
import { Route as AuthenticatedExportsRouteImport } from './routes/_authenticated/exports'
import { Route as AuthenticatedErrorReportsRouteImport } from './routes/_authenticated/error-reports'
import { Route as AuthenticatedEmailTemplatesRouteImport } from './routes/_authenticated/email-templates'
import { Route as AuthenticatedEmailLogRouteImport } from './routes/_authenticated/email-log'
import { Route as AuthenticatedCompaniesRouteImport } from './routes/_authenticated/companies'
import { Route as AuthenticatedCardRouteImport } from './routes/_authenticated/card'
import { Route as AuthenticatedBudgetRouteImport } from './routes/_authenticated/budget'
import { Route as AuthenticatedAuditLogRouteImport } from './routes/_authenticated/audit-log'
import { Route as AuthenticatedAllProductsRouteImport } from './routes/_authenticated/all-products'
import { Route as AuthenticatedProductsProductIdRouteImport } from './routes/_authenticated/products_.$productId'
import { Route as AuthenticatedMyETicketsRouteImport } from './routes/_authenticated/my.e-tickets'
import { Route as AuthenticatedImportsNewRouteImport } from './routes/_authenticated/imports_.new'
import { Route as AuthenticatedImportsImportIdRouteImport } from './routes/_authenticated/imports_.$importId'
import { Route as AuthenticatedEmailTemplatesTemplateIdRouteImport } from './routes/_authenticated/email-templates_.$templateId'
import { Route as AuthenticatedDashboardTemplatesTemplateIdRouteImport } from './routes/_authenticated/dashboard-templates_.$templateId'
import { Route as AuthenticatedCompaniesCompanyIdRouteRouteImport } from './routes/_authenticated/companies_.$companyId/route'
import { Route as AuthenticatedCompaniesCompanyIdUsersRouteImport } from './routes/_authenticated/companies_.$companyId/users'
import { Route as AuthenticatedCompaniesCompanyIdPersonalCardsRouteImport } from './routes/_authenticated/companies_.$companyId/personal-cards'
import { Route as AuthenticatedCompaniesCompanyIdOnboardingRouteImport } from './routes/_authenticated/companies_.$companyId/onboarding'
import { Route as AuthenticatedCompaniesCompanyIdETicketsRouteImport } from './routes/_authenticated/companies_.$companyId/e-tickets'
import { Route as AuthenticatedCompaniesCompanyIdDayCardsRouteImport } from './routes/_authenticated/companies_.$companyId/day-cards'
import { Route as AuthenticatedCompaniesCompanyIdAnonymousCardsRouteImport } from './routes/_authenticated/companies_.$companyId/anonymous-cards'
import { Route as AuthenticatedCompaniesCompanyIdUsersUserIdRouteRouteImport } from './routes/_authenticated/companies_.$companyId/users_.$userId/route'
import { Route as AuthenticatedCompaniesCompanyIdUsersUserIdTransactionsRouteImport } from './routes/_authenticated/companies_.$companyId/users_.$userId/transactions'
import { Route as AuthenticatedCompaniesCompanyIdUsersUserIdSubscriptionsRouteImport } from './routes/_authenticated/companies_.$companyId/users_.$userId/subscriptions'
import { Route as AuthenticatedCompaniesCompanyIdUsersUserIdSubscriptionRouteImport } from './routes/_authenticated/companies_.$companyId/users_.$userId/subscription'
import { Route as AuthenticatedCompaniesCompanyIdUsersUserIdProfileRouteImport } from './routes/_authenticated/companies_.$companyId/users_.$userId/profile'
import { Route as AuthenticatedCompaniesCompanyIdUsersUserIdMessagesRouteImport } from './routes/_authenticated/companies_.$companyId/users_.$userId/messages'
import { Route as AuthenticatedCompaniesCompanyIdUsersUserIdCardRouteImport } from './routes/_authenticated/companies_.$companyId/users_.$userId/card'
import { Route as AuthenticatedCompaniesCompanyIdUsersUserIdBudgetRouteImport } from './routes/_authenticated/companies_.$companyId/users_.$userId/budget'

const LoginLazyRouteImport = createFileRoute('/login')()
const AuthCallbackLazyRouteImport = createFileRoute('/auth/callback')()
const AuthenticatedTravelCostsLazyRouteImport = createFileRoute(
  '/_authenticated/travel-costs',
)()
const AuthenticatedSubscriptionTypesLazyRouteImport = createFileRoute(
  '/_authenticated/subscription-types',
)()
const AuthenticatedSettingsLazyRouteImport = createFileRoute(
  '/_authenticated/settings',
)()
const AuthenticatedLoginAsLazyRouteImport = createFileRoute(
  '/_authenticated/login-as',
)()
const AuthenticatedInvoiceApprovalsLazyRouteImport = createFileRoute(
  '/_authenticated/invoice-approvals',
)()
const AuthenticatedDayTicketsLazyRouteImport = createFileRoute(
  '/_authenticated/day-tickets',
)()
const AuthenticatedDashboardTemplatesLazyRouteImport = createFileRoute(
  '/_authenticated/dashboard-templates',
)()
const AuthenticatedCustomerManagementLazyRouteImport = createFileRoute(
  '/_authenticated/customer-management',
)()
const AuthenticatedChangelogLazyRouteImport = createFileRoute(
  '/_authenticated/changelog',
)()
const AuthenticatedCardInfoLazyRouteImport = createFileRoute(
  '/_authenticated/card-info',
)()
const AuthenticatedBrandProductsLazyRouteImport = createFileRoute(
  '/_authenticated/brand-products',
)()
const AuthenticatedSubscriptionsExportLazyRouteImport = createFileRoute(
  '/_authenticated/subscriptions_/export',
)()
const AuthenticatedDashboardTemplatesNewLazyRouteImport = createFileRoute(
  '/_authenticated/dashboard-templates_/new',
)()
const AuthenticatedApprovalPendingLazyRouteImport = createFileRoute(
  '/_authenticated/approval/pending',
)()
const AuthenticatedCompaniesCompanyIdIndexLazyRouteImport = createFileRoute(
  '/_authenticated/companies_/$companyId/',
)()
const AuthenticatedMyETicketsETicketIdLazyRouteImport = createFileRoute(
  '/_authenticated/my/e-tickets_/$eTicketId',
)()
const AuthenticatedCompaniesCompanyIdTravellersLazyRouteImport =
  createFileRoute('/_authenticated/companies_/$companyId/travellers')()
const AuthenticatedCompaniesCompanyIdSettingsLazyRouteImport = createFileRoute(
  '/_authenticated/companies_/$companyId/settings',
)()
const AuthenticatedCompaniesCompanyIdRepricingLazyRouteImport = createFileRoute(
  '/_authenticated/companies_/$companyId/repricing',
)()
const AuthenticatedCompaniesCompanyIdPropositionsLazyRouteImport =
  createFileRoute('/_authenticated/companies_/$companyId/propositions')()
const AuthenticatedCompaniesCompanyIdProjectCodesLazyRouteImport =
  createFileRoute('/_authenticated/companies_/$companyId/project-codes')()
const AuthenticatedCompaniesCompanyIdNotificationsLazyRouteImport =
  createFileRoute('/_authenticated/companies_/$companyId/notifications')()
const AuthenticatedCompaniesCompanyIdInvoicingLazyRouteImport = createFileRoute(
  '/_authenticated/companies_/$companyId/invoicing',
)()
const AuthenticatedCompaniesCompanyIdFreeFieldsLazyRouteImport =
  createFileRoute('/_authenticated/companies_/$companyId/free-fields')()
const AuthenticatedCompaniesCompanyIdDistributionPointsLazyRouteImport =
  createFileRoute('/_authenticated/companies_/$companyId/distribution-points')()
const AuthenticatedCompaniesCompanyIdDetailsLazyRouteImport = createFileRoute(
  '/_authenticated/companies_/$companyId/details',
)()
const AuthenticatedCompaniesCompanyIdDepartmentsLazyRouteImport =
  createFileRoute('/_authenticated/companies_/$companyId/departments')()
const AuthenticatedCompaniesCompanyIdCustomFieldsLazyRouteImport =
  createFileRoute('/_authenticated/companies_/$companyId/custom-fields')()
const AuthenticatedCompaniesCompanyIdCostCentersLazyRouteImport =
  createFileRoute('/_authenticated/companies_/$companyId/cost-centers')()
const AuthenticatedCompaniesCompanyIdAssignCardsLazyRouteImport =
  createFileRoute('/_authenticated/companies_/$companyId/assign-cards')()
const AuthenticatedCompaniesCompanyIdAdminsLazyRouteImport = createFileRoute(
  '/_authenticated/companies_/$companyId/admins',
)()
const AuthenticatedCompaniesCompanyIdInvoicingLinesLazyRouteImport =
  createFileRoute('/_authenticated/companies_/$companyId/invoicing_/lines')()
const AuthenticatedCompaniesCompanyIdUsersUserIdIndexLazyRouteImport =
  createFileRoute('/_authenticated/companies_/$companyId/users_/$userId/')()
const AuthenticatedCompaniesCompanyIdUsersUserIdSettingsLazyRouteImport =
  createFileRoute(
    '/_authenticated/companies_/$companyId/users_/$userId/settings',
  )()

const LoginLazyRoute = LoginLazyRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/login.lazy').then((d) => d.Route))
const UitnodigingAccepterenRoute = UitnodigingAccepterenRouteImport.update({
  id: '/uitnodiging-accepteren',
  path: '/uitnodiging-accepteren',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/uitnodiging-accepteren.lazy').then((d) => d.Route),
)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/index.lazy').then((d) => d.Route),
)
const AuthCallbackLazyRoute = AuthCallbackLazyRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/auth/callback.lazy').then((d) => d.Route))
const AuthenticatedTravelCostsLazyRoute =
  AuthenticatedTravelCostsLazyRouteImport.update({
    id: '/travel-costs',
    path: '/travel-costs',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/travel-costs.lazy').then((d) => d.Route),
  )
const AuthenticatedSubscriptionTypesLazyRoute =
  AuthenticatedSubscriptionTypesLazyRouteImport.update({
    id: '/subscription-types',
    path: '/subscription-types',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/subscription-types.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedSettingsLazyRoute =
  AuthenticatedSettingsLazyRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/settings.lazy').then((d) => d.Route),
  )
const AuthenticatedLoginAsLazyRoute =
  AuthenticatedLoginAsLazyRouteImport.update({
    id: '/login-as',
    path: '/login-as',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/login-as.lazy').then((d) => d.Route),
  )
const AuthenticatedInvoiceApprovalsLazyRoute =
  AuthenticatedInvoiceApprovalsLazyRouteImport.update({
    id: '/invoice-approvals',
    path: '/invoice-approvals',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/invoice-approvals.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedDayTicketsLazyRoute =
  AuthenticatedDayTicketsLazyRouteImport.update({
    id: '/day-tickets',
    path: '/day-tickets',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/day-tickets.lazy').then((d) => d.Route),
  )
const AuthenticatedDashboardTemplatesLazyRoute =
  AuthenticatedDashboardTemplatesLazyRouteImport.update({
    id: '/dashboard-templates',
    path: '/dashboard-templates',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/dashboard-templates.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCustomerManagementLazyRoute =
  AuthenticatedCustomerManagementLazyRouteImport.update({
    id: '/customer-management',
    path: '/customer-management',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/customer-management.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedChangelogLazyRoute =
  AuthenticatedChangelogLazyRouteImport.update({
    id: '/changelog',
    path: '/changelog',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/changelog.lazy').then((d) => d.Route),
  )
const AuthenticatedCardInfoLazyRoute =
  AuthenticatedCardInfoLazyRouteImport.update({
    id: '/card-info',
    path: '/card-info',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/card-info.lazy').then((d) => d.Route),
  )
const AuthenticatedBrandProductsLazyRoute =
  AuthenticatedBrandProductsLazyRouteImport.update({
    id: '/brand-products',
    path: '/brand-products',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/brand-products.lazy').then((d) => d.Route),
  )
const AuthenticatedTransactionsRoute =
  AuthenticatedTransactionsRouteImport.update({
    id: '/transactions',
    path: '/transactions',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/transactions.lazy').then((d) => d.Route),
  )
const AuthenticatedSubscriptionsRoute =
  AuthenticatedSubscriptionsRouteImport.update({
    id: '/subscriptions',
    path: '/subscriptions',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/subscriptions.lazy').then((d) => d.Route),
  )
const AuthenticatedSubscriptionRoute =
  AuthenticatedSubscriptionRouteImport.update({
    id: '/subscription',
    path: '/subscription',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/subscription.lazy').then((d) => d.Route),
  )
const AuthenticatedSharedCardsRoute =
  AuthenticatedSharedCardsRouteImport.update({
    id: '/shared-cards',
    path: '/shared-cards',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/shared-cards.lazy').then((d) => d.Route),
  )
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthenticatedRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/profile.lazy').then((d) => d.Route),
)
const AuthenticatedProductsRoute = AuthenticatedProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedOvCardsRoute = AuthenticatedOvCardsRouteImport.update({
  id: '/ov-cards',
  path: '/ov-cards',
  getParentRoute: () => AuthenticatedRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/ov-cards.lazy').then((d) => d.Route),
)
const AuthenticatedMessagesRoute = AuthenticatedMessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => AuthenticatedRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/messages.lazy').then((d) => d.Route),
)
const AuthenticatedImportsRoute = AuthenticatedImportsRouteImport.update({
  id: '/imports',
  path: '/imports',
  getParentRoute: () => AuthenticatedRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/imports.lazy').then((d) => d.Route),
)
const AuthenticatedExportsRoute = AuthenticatedExportsRouteImport.update({
  id: '/exports',
  path: '/exports',
  getParentRoute: () => AuthenticatedRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/exports.lazy').then((d) => d.Route),
)
const AuthenticatedErrorReportsRoute =
  AuthenticatedErrorReportsRouteImport.update({
    id: '/error-reports',
    path: '/error-reports',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/error-reports.lazy').then((d) => d.Route),
  )
const AuthenticatedEmailTemplatesRoute =
  AuthenticatedEmailTemplatesRouteImport.update({
    id: '/email-templates',
    path: '/email-templates',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/email-templates.lazy').then((d) => d.Route),
  )
const AuthenticatedEmailLogRoute = AuthenticatedEmailLogRouteImport.update({
  id: '/email-log',
  path: '/email-log',
  getParentRoute: () => AuthenticatedRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/email-log.lazy').then((d) => d.Route),
)
const AuthenticatedCompaniesRoute = AuthenticatedCompaniesRouteImport.update({
  id: '/companies',
  path: '/companies',
  getParentRoute: () => AuthenticatedRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/companies.lazy').then((d) => d.Route),
)
const AuthenticatedCardRoute = AuthenticatedCardRouteImport.update({
  id: '/card',
  path: '/card',
  getParentRoute: () => AuthenticatedRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/card.lazy').then((d) => d.Route),
)
const AuthenticatedBudgetRoute = AuthenticatedBudgetRouteImport.update({
  id: '/budget',
  path: '/budget',
  getParentRoute: () => AuthenticatedRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/budget.lazy').then((d) => d.Route),
)
const AuthenticatedAuditLogRoute = AuthenticatedAuditLogRouteImport.update({
  id: '/audit-log',
  path: '/audit-log',
  getParentRoute: () => AuthenticatedRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/audit-log.lazy').then((d) => d.Route),
)
const AuthenticatedAllProductsRoute =
  AuthenticatedAllProductsRouteImport.update({
    id: '/all-products',
    path: '/all-products',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/all-products.lazy').then((d) => d.Route),
  )
const AuthenticatedSubscriptionsExportLazyRoute =
  AuthenticatedSubscriptionsExportLazyRouteImport.update({
    id: '/subscriptions_/export',
    path: '/subscriptions/export',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/subscriptions_.export.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedDashboardTemplatesNewLazyRoute =
  AuthenticatedDashboardTemplatesNewLazyRouteImport.update({
    id: '/dashboard-templates_/new',
    path: '/dashboard-templates/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/dashboard-templates_.new.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedApprovalPendingLazyRoute =
  AuthenticatedApprovalPendingLazyRouteImport.update({
    id: '/approval/pending',
    path: '/approval/pending',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/approval.pending.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedProductsProductIdRoute =
  AuthenticatedProductsProductIdRouteImport.update({
    id: '/products_/$productId',
    path: '/products/$productId',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/products_.$productId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedMyETicketsRoute = AuthenticatedMyETicketsRouteImport.update({
  id: '/my/e-tickets',
  path: '/my/e-tickets',
  getParentRoute: () => AuthenticatedRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/my.e-tickets.lazy').then((d) => d.Route),
)
const AuthenticatedImportsNewRoute = AuthenticatedImportsNewRouteImport.update({
  id: '/imports_/new',
  path: '/imports/new',
  getParentRoute: () => AuthenticatedRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/imports_.new.lazy').then((d) => d.Route),
)
const AuthenticatedImportsImportIdRoute =
  AuthenticatedImportsImportIdRouteImport.update({
    id: '/imports_/$importId',
    path: '/imports/$importId',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/imports_.$importId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedEmailTemplatesTemplateIdRoute =
  AuthenticatedEmailTemplatesTemplateIdRouteImport.update({
    id: '/email-templates_/$templateId',
    path: '/email-templates/$templateId',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/email-templates_.$templateId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedDashboardTemplatesTemplateIdRoute =
  AuthenticatedDashboardTemplatesTemplateIdRouteImport.update({
    id: '/dashboard-templates_/$templateId',
    path: '/dashboard-templates/$templateId',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/dashboard-templates_.$templateId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompaniesCompanyIdRouteRoute =
  AuthenticatedCompaniesCompanyIdRouteRouteImport.update({
    id: '/companies_/$companyId',
    path: '/companies/$companyId',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/companies_.$companyId/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompaniesCompanyIdIndexLazyRoute =
  AuthenticatedCompaniesCompanyIdIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/companies_.$companyId/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedMyETicketsETicketIdLazyRoute =
  AuthenticatedMyETicketsETicketIdLazyRouteImport.update({
    id: '/my/e-tickets_/$eTicketId',
    path: '/my/e-tickets/$eTicketId',
    getParentRoute: () => AuthenticatedRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/my.e-tickets_.$eTicketId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompaniesCompanyIdTravellersLazyRoute =
  AuthenticatedCompaniesCompanyIdTravellersLazyRouteImport.update({
    id: '/travellers',
    path: '/travellers',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/companies_.$companyId/travellers.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompaniesCompanyIdSettingsLazyRoute =
  AuthenticatedCompaniesCompanyIdSettingsLazyRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/companies_.$companyId/settings.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompaniesCompanyIdRepricingLazyRoute =
  AuthenticatedCompaniesCompanyIdRepricingLazyRouteImport.update({
    id: '/repricing',
    path: '/repricing',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/companies_.$companyId/repricing.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompaniesCompanyIdPropositionsLazyRoute =
  AuthenticatedCompaniesCompanyIdPropositionsLazyRouteImport.update({
    id: '/propositions',
    path: '/propositions',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/companies_.$companyId/propositions.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompaniesCompanyIdProjectCodesLazyRoute =
  AuthenticatedCompaniesCompanyIdProjectCodesLazyRouteImport.update({
    id: '/project-codes',
    path: '/project-codes',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/companies_.$companyId/project-codes.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompaniesCompanyIdNotificationsLazyRoute =
  AuthenticatedCompaniesCompanyIdNotificationsLazyRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/companies_.$companyId/notifications.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompaniesCompanyIdInvoicingLazyRoute =
  AuthenticatedCompaniesCompanyIdInvoicingLazyRouteImport.update({
    id: '/invoicing',
    path: '/invoicing',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/companies_.$companyId/invoicing.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompaniesCompanyIdFreeFieldsLazyRoute =
  AuthenticatedCompaniesCompanyIdFreeFieldsLazyRouteImport.update({
    id: '/free-fields',
    path: '/free-fields',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/companies_.$companyId/free-fields.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompaniesCompanyIdDistributionPointsLazyRoute =
  AuthenticatedCompaniesCompanyIdDistributionPointsLazyRouteImport.update({
    id: '/distribution-points',
    path: '/distribution-points',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/companies_.$companyId/distribution-points.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompaniesCompanyIdDetailsLazyRoute =
  AuthenticatedCompaniesCompanyIdDetailsLazyRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/companies_.$companyId/details.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompaniesCompanyIdDepartmentsLazyRoute =
  AuthenticatedCompaniesCompanyIdDepartmentsLazyRouteImport.update({
    id: '/departments',
    path: '/departments',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/companies_.$companyId/departments.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompaniesCompanyIdCustomFieldsLazyRoute =
  AuthenticatedCompaniesCompanyIdCustomFieldsLazyRouteImport.update({
    id: '/custom-fields',
    path: '/custom-fields',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/companies_.$companyId/custom-fields.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompaniesCompanyIdCostCentersLazyRoute =
  AuthenticatedCompaniesCompanyIdCostCentersLazyRouteImport.update({
    id: '/cost-centers',
    path: '/cost-centers',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/companies_.$companyId/cost-centers.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompaniesCompanyIdAssignCardsLazyRoute =
  AuthenticatedCompaniesCompanyIdAssignCardsLazyRouteImport.update({
    id: '/assign-cards',
    path: '/assign-cards',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/companies_.$companyId/assign-cards.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompaniesCompanyIdAdminsLazyRoute =
  AuthenticatedCompaniesCompanyIdAdminsLazyRouteImport.update({
    id: '/admins',
    path: '/admins',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/companies_.$companyId/admins.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompaniesCompanyIdUsersRoute =
  AuthenticatedCompaniesCompanyIdUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/companies_.$companyId/users.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompaniesCompanyIdPersonalCardsRoute =
  AuthenticatedCompaniesCompanyIdPersonalCardsRouteImport.update({
    id: '/personal-cards',
    path: '/personal-cards',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/companies_.$companyId/personal-cards.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompaniesCompanyIdOnboardingRoute =
  AuthenticatedCompaniesCompanyIdOnboardingRouteImport.update({
    id: '/onboarding',
    path: '/onboarding',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/companies_.$companyId/onboarding.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompaniesCompanyIdETicketsRoute =
  AuthenticatedCompaniesCompanyIdETicketsRouteImport.update({
    id: '/e-tickets',
    path: '/e-tickets',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/companies_.$companyId/e-tickets.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompaniesCompanyIdDayCardsRoute =
  AuthenticatedCompaniesCompanyIdDayCardsRouteImport.update({
    id: '/day-cards',
    path: '/day-cards',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/companies_.$companyId/day-cards.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompaniesCompanyIdAnonymousCardsRoute =
  AuthenticatedCompaniesCompanyIdAnonymousCardsRouteImport.update({
    id: '/anonymous-cards',
    path: '/anonymous-cards',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/companies_.$companyId/anonymous-cards.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompaniesCompanyIdInvoicingLinesLazyRoute =
  AuthenticatedCompaniesCompanyIdInvoicingLinesLazyRouteImport.update({
    id: '/invoicing_/lines',
    path: '/invoicing/lines',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/companies_.$companyId/invoicing_.lines.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompaniesCompanyIdUsersUserIdRouteRoute =
  AuthenticatedCompaniesCompanyIdUsersUserIdRouteRouteImport.update({
    id: '/users_/$userId',
    path: '/users/$userId',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/companies_.$companyId/users_.$userId/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompaniesCompanyIdUsersUserIdIndexLazyRoute =
  AuthenticatedCompaniesCompanyIdUsersUserIdIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdUsersUserIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/companies_.$companyId/users_.$userId/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompaniesCompanyIdUsersUserIdSettingsLazyRoute =
  AuthenticatedCompaniesCompanyIdUsersUserIdSettingsLazyRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdUsersUserIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/companies_.$companyId/users_.$userId/settings.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompaniesCompanyIdUsersUserIdTransactionsRoute =
  AuthenticatedCompaniesCompanyIdUsersUserIdTransactionsRouteImport.update({
    id: '/transactions',
    path: '/transactions',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdUsersUserIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/companies_.$companyId/users_.$userId/transactions.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompaniesCompanyIdUsersUserIdSubscriptionsRoute =
  AuthenticatedCompaniesCompanyIdUsersUserIdSubscriptionsRouteImport.update({
    id: '/subscriptions',
    path: '/subscriptions',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdUsersUserIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/companies_.$companyId/users_.$userId/subscriptions.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompaniesCompanyIdUsersUserIdSubscriptionRoute =
  AuthenticatedCompaniesCompanyIdUsersUserIdSubscriptionRouteImport.update({
    id: '/subscription',
    path: '/subscription',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdUsersUserIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/companies_.$companyId/users_.$userId/subscription.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompaniesCompanyIdUsersUserIdProfileRoute =
  AuthenticatedCompaniesCompanyIdUsersUserIdProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdUsersUserIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/companies_.$companyId/users_.$userId/profile.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompaniesCompanyIdUsersUserIdMessagesRoute =
  AuthenticatedCompaniesCompanyIdUsersUserIdMessagesRouteImport.update({
    id: '/messages',
    path: '/messages',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdUsersUserIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/companies_.$companyId/users_.$userId/messages.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompaniesCompanyIdUsersUserIdCardRoute =
  AuthenticatedCompaniesCompanyIdUsersUserIdCardRouteImport.update({
    id: '/card',
    path: '/card',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdUsersUserIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/companies_.$companyId/users_.$userId/card.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedCompaniesCompanyIdUsersUserIdBudgetRoute =
  AuthenticatedCompaniesCompanyIdUsersUserIdBudgetRouteImport.update({
    id: '/budget',
    path: '/budget',
    getParentRoute: () => AuthenticatedCompaniesCompanyIdUsersUserIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/companies_.$companyId/users_.$userId/budget.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/uitnodiging-accepteren': typeof UitnodigingAccepterenRoute
  '/login': typeof LoginLazyRoute
  '/all-products': typeof AuthenticatedAllProductsRoute
  '/audit-log': typeof AuthenticatedAuditLogRoute
  '/budget': typeof AuthenticatedBudgetRoute
  '/card': typeof AuthenticatedCardRoute
  '/companies': typeof AuthenticatedCompaniesRoute
  '/email-log': typeof AuthenticatedEmailLogRoute
  '/email-templates': typeof AuthenticatedEmailTemplatesRoute
  '/error-reports': typeof AuthenticatedErrorReportsRoute
  '/exports': typeof AuthenticatedExportsRoute
  '/imports': typeof AuthenticatedImportsRoute
  '/messages': typeof AuthenticatedMessagesRoute
  '/ov-cards': typeof AuthenticatedOvCardsRoute
  '/products': typeof AuthenticatedProductsRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/shared-cards': typeof AuthenticatedSharedCardsRoute
  '/subscription': typeof AuthenticatedSubscriptionRoute
  '/subscriptions': typeof AuthenticatedSubscriptionsRoute
  '/transactions': typeof AuthenticatedTransactionsRoute
  '/brand-products': typeof AuthenticatedBrandProductsLazyRoute
  '/card-info': typeof AuthenticatedCardInfoLazyRoute
  '/changelog': typeof AuthenticatedChangelogLazyRoute
  '/customer-management': typeof AuthenticatedCustomerManagementLazyRoute
  '/dashboard-templates': typeof AuthenticatedDashboardTemplatesLazyRoute
  '/day-tickets': typeof AuthenticatedDayTicketsLazyRoute
  '/invoice-approvals': typeof AuthenticatedInvoiceApprovalsLazyRoute
  '/login-as': typeof AuthenticatedLoginAsLazyRoute
  '/settings': typeof AuthenticatedSettingsLazyRoute
  '/subscription-types': typeof AuthenticatedSubscriptionTypesLazyRoute
  '/travel-costs': typeof AuthenticatedTravelCostsLazyRoute
  '/auth/callback': typeof AuthCallbackLazyRoute
  '/companies/$companyId': typeof AuthenticatedCompaniesCompanyIdRouteRouteWithChildren
  '/dashboard-templates/$templateId': typeof AuthenticatedDashboardTemplatesTemplateIdRoute
  '/email-templates/$templateId': typeof AuthenticatedEmailTemplatesTemplateIdRoute
  '/imports/$importId': typeof AuthenticatedImportsImportIdRoute
  '/imports/new': typeof AuthenticatedImportsNewRoute
  '/my/e-tickets': typeof AuthenticatedMyETicketsRoute
  '/products/$productId': typeof AuthenticatedProductsProductIdRoute
  '/approval/pending': typeof AuthenticatedApprovalPendingLazyRoute
  '/dashboard-templates/new': typeof AuthenticatedDashboardTemplatesNewLazyRoute
  '/subscriptions/export': typeof AuthenticatedSubscriptionsExportLazyRoute
  '/companies/$companyId/anonymous-cards': typeof AuthenticatedCompaniesCompanyIdAnonymousCardsRoute
  '/companies/$companyId/day-cards': typeof AuthenticatedCompaniesCompanyIdDayCardsRoute
  '/companies/$companyId/e-tickets': typeof AuthenticatedCompaniesCompanyIdETicketsRoute
  '/companies/$companyId/onboarding': typeof AuthenticatedCompaniesCompanyIdOnboardingRoute
  '/companies/$companyId/personal-cards': typeof AuthenticatedCompaniesCompanyIdPersonalCardsRoute
  '/companies/$companyId/users': typeof AuthenticatedCompaniesCompanyIdUsersRoute
  '/companies/$companyId/admins': typeof AuthenticatedCompaniesCompanyIdAdminsLazyRoute
  '/companies/$companyId/assign-cards': typeof AuthenticatedCompaniesCompanyIdAssignCardsLazyRoute
  '/companies/$companyId/cost-centers': typeof AuthenticatedCompaniesCompanyIdCostCentersLazyRoute
  '/companies/$companyId/custom-fields': typeof AuthenticatedCompaniesCompanyIdCustomFieldsLazyRoute
  '/companies/$companyId/departments': typeof AuthenticatedCompaniesCompanyIdDepartmentsLazyRoute
  '/companies/$companyId/details': typeof AuthenticatedCompaniesCompanyIdDetailsLazyRoute
  '/companies/$companyId/distribution-points': typeof AuthenticatedCompaniesCompanyIdDistributionPointsLazyRoute
  '/companies/$companyId/free-fields': typeof AuthenticatedCompaniesCompanyIdFreeFieldsLazyRoute
  '/companies/$companyId/invoicing': typeof AuthenticatedCompaniesCompanyIdInvoicingLazyRoute
  '/companies/$companyId/notifications': typeof AuthenticatedCompaniesCompanyIdNotificationsLazyRoute
  '/companies/$companyId/project-codes': typeof AuthenticatedCompaniesCompanyIdProjectCodesLazyRoute
  '/companies/$companyId/propositions': typeof AuthenticatedCompaniesCompanyIdPropositionsLazyRoute
  '/companies/$companyId/repricing': typeof AuthenticatedCompaniesCompanyIdRepricingLazyRoute
  '/companies/$companyId/settings': typeof AuthenticatedCompaniesCompanyIdSettingsLazyRoute
  '/companies/$companyId/travellers': typeof AuthenticatedCompaniesCompanyIdTravellersLazyRoute
  '/my/e-tickets/$eTicketId': typeof AuthenticatedMyETicketsETicketIdLazyRoute
  '/companies/$companyId/': typeof AuthenticatedCompaniesCompanyIdIndexLazyRoute
  '/companies/$companyId/users/$userId': typeof AuthenticatedCompaniesCompanyIdUsersUserIdRouteRouteWithChildren
  '/companies/$companyId/invoicing/lines': typeof AuthenticatedCompaniesCompanyIdInvoicingLinesLazyRoute
  '/companies/$companyId/users/$userId/budget': typeof AuthenticatedCompaniesCompanyIdUsersUserIdBudgetRoute
  '/companies/$companyId/users/$userId/card': typeof AuthenticatedCompaniesCompanyIdUsersUserIdCardRoute
  '/companies/$companyId/users/$userId/messages': typeof AuthenticatedCompaniesCompanyIdUsersUserIdMessagesRoute
  '/companies/$companyId/users/$userId/profile': typeof AuthenticatedCompaniesCompanyIdUsersUserIdProfileRoute
  '/companies/$companyId/users/$userId/subscription': typeof AuthenticatedCompaniesCompanyIdUsersUserIdSubscriptionRoute
  '/companies/$companyId/users/$userId/subscriptions': typeof AuthenticatedCompaniesCompanyIdUsersUserIdSubscriptionsRoute
  '/companies/$companyId/users/$userId/transactions': typeof AuthenticatedCompaniesCompanyIdUsersUserIdTransactionsRoute
  '/companies/$companyId/users/$userId/settings': typeof AuthenticatedCompaniesCompanyIdUsersUserIdSettingsLazyRoute
  '/companies/$companyId/users/$userId/': typeof AuthenticatedCompaniesCompanyIdUsersUserIdIndexLazyRoute
}
export interface FileRoutesByTo {
  '/uitnodiging-accepteren': typeof UitnodigingAccepterenRoute
  '/login': typeof LoginLazyRoute
  '/all-products': typeof AuthenticatedAllProductsRoute
  '/audit-log': typeof AuthenticatedAuditLogRoute
  '/budget': typeof AuthenticatedBudgetRoute
  '/card': typeof AuthenticatedCardRoute
  '/companies': typeof AuthenticatedCompaniesRoute
  '/email-log': typeof AuthenticatedEmailLogRoute
  '/email-templates': typeof AuthenticatedEmailTemplatesRoute
  '/error-reports': typeof AuthenticatedErrorReportsRoute
  '/exports': typeof AuthenticatedExportsRoute
  '/imports': typeof AuthenticatedImportsRoute
  '/messages': typeof AuthenticatedMessagesRoute
  '/ov-cards': typeof AuthenticatedOvCardsRoute
  '/products': typeof AuthenticatedProductsRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/shared-cards': typeof AuthenticatedSharedCardsRoute
  '/subscription': typeof AuthenticatedSubscriptionRoute
  '/subscriptions': typeof AuthenticatedSubscriptionsRoute
  '/transactions': typeof AuthenticatedTransactionsRoute
  '/brand-products': typeof AuthenticatedBrandProductsLazyRoute
  '/card-info': typeof AuthenticatedCardInfoLazyRoute
  '/changelog': typeof AuthenticatedChangelogLazyRoute
  '/customer-management': typeof AuthenticatedCustomerManagementLazyRoute
  '/dashboard-templates': typeof AuthenticatedDashboardTemplatesLazyRoute
  '/day-tickets': typeof AuthenticatedDayTicketsLazyRoute
  '/invoice-approvals': typeof AuthenticatedInvoiceApprovalsLazyRoute
  '/login-as': typeof AuthenticatedLoginAsLazyRoute
  '/settings': typeof AuthenticatedSettingsLazyRoute
  '/subscription-types': typeof AuthenticatedSubscriptionTypesLazyRoute
  '/travel-costs': typeof AuthenticatedTravelCostsLazyRoute
  '/auth/callback': typeof AuthCallbackLazyRoute
  '/': typeof AuthenticatedIndexRoute
  '/dashboard-templates/$templateId': typeof AuthenticatedDashboardTemplatesTemplateIdRoute
  '/email-templates/$templateId': typeof AuthenticatedEmailTemplatesTemplateIdRoute
  '/imports/$importId': typeof AuthenticatedImportsImportIdRoute
  '/imports/new': typeof AuthenticatedImportsNewRoute
  '/my/e-tickets': typeof AuthenticatedMyETicketsRoute
  '/products/$productId': typeof AuthenticatedProductsProductIdRoute
  '/approval/pending': typeof AuthenticatedApprovalPendingLazyRoute
  '/dashboard-templates/new': typeof AuthenticatedDashboardTemplatesNewLazyRoute
  '/subscriptions/export': typeof AuthenticatedSubscriptionsExportLazyRoute
  '/companies/$companyId/anonymous-cards': typeof AuthenticatedCompaniesCompanyIdAnonymousCardsRoute
  '/companies/$companyId/day-cards': typeof AuthenticatedCompaniesCompanyIdDayCardsRoute
  '/companies/$companyId/e-tickets': typeof AuthenticatedCompaniesCompanyIdETicketsRoute
  '/companies/$companyId/onboarding': typeof AuthenticatedCompaniesCompanyIdOnboardingRoute
  '/companies/$companyId/personal-cards': typeof AuthenticatedCompaniesCompanyIdPersonalCardsRoute
  '/companies/$companyId/users': typeof AuthenticatedCompaniesCompanyIdUsersRoute
  '/companies/$companyId/admins': typeof AuthenticatedCompaniesCompanyIdAdminsLazyRoute
  '/companies/$companyId/assign-cards': typeof AuthenticatedCompaniesCompanyIdAssignCardsLazyRoute
  '/companies/$companyId/cost-centers': typeof AuthenticatedCompaniesCompanyIdCostCentersLazyRoute
  '/companies/$companyId/custom-fields': typeof AuthenticatedCompaniesCompanyIdCustomFieldsLazyRoute
  '/companies/$companyId/departments': typeof AuthenticatedCompaniesCompanyIdDepartmentsLazyRoute
  '/companies/$companyId/details': typeof AuthenticatedCompaniesCompanyIdDetailsLazyRoute
  '/companies/$companyId/distribution-points': typeof AuthenticatedCompaniesCompanyIdDistributionPointsLazyRoute
  '/companies/$companyId/free-fields': typeof AuthenticatedCompaniesCompanyIdFreeFieldsLazyRoute
  '/companies/$companyId/invoicing': typeof AuthenticatedCompaniesCompanyIdInvoicingLazyRoute
  '/companies/$companyId/notifications': typeof AuthenticatedCompaniesCompanyIdNotificationsLazyRoute
  '/companies/$companyId/project-codes': typeof AuthenticatedCompaniesCompanyIdProjectCodesLazyRoute
  '/companies/$companyId/propositions': typeof AuthenticatedCompaniesCompanyIdPropositionsLazyRoute
  '/companies/$companyId/repricing': typeof AuthenticatedCompaniesCompanyIdRepricingLazyRoute
  '/companies/$companyId/settings': typeof AuthenticatedCompaniesCompanyIdSettingsLazyRoute
  '/companies/$companyId/travellers': typeof AuthenticatedCompaniesCompanyIdTravellersLazyRoute
  '/my/e-tickets/$eTicketId': typeof AuthenticatedMyETicketsETicketIdLazyRoute
  '/companies/$companyId': typeof AuthenticatedCompaniesCompanyIdIndexLazyRoute
  '/companies/$companyId/invoicing/lines': typeof AuthenticatedCompaniesCompanyIdInvoicingLinesLazyRoute
  '/companies/$companyId/users/$userId/budget': typeof AuthenticatedCompaniesCompanyIdUsersUserIdBudgetRoute
  '/companies/$companyId/users/$userId/card': typeof AuthenticatedCompaniesCompanyIdUsersUserIdCardRoute
  '/companies/$companyId/users/$userId/messages': typeof AuthenticatedCompaniesCompanyIdUsersUserIdMessagesRoute
  '/companies/$companyId/users/$userId/profile': typeof AuthenticatedCompaniesCompanyIdUsersUserIdProfileRoute
  '/companies/$companyId/users/$userId/subscription': typeof AuthenticatedCompaniesCompanyIdUsersUserIdSubscriptionRoute
  '/companies/$companyId/users/$userId/subscriptions': typeof AuthenticatedCompaniesCompanyIdUsersUserIdSubscriptionsRoute
  '/companies/$companyId/users/$userId/transactions': typeof AuthenticatedCompaniesCompanyIdUsersUserIdTransactionsRoute
  '/companies/$companyId/users/$userId/settings': typeof AuthenticatedCompaniesCompanyIdUsersUserIdSettingsLazyRoute
  '/companies/$companyId/users/$userId': typeof AuthenticatedCompaniesCompanyIdUsersUserIdIndexLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/uitnodiging-accepteren': typeof UitnodigingAccepterenRoute
  '/login': typeof LoginLazyRoute
  '/_authenticated/all-products': typeof AuthenticatedAllProductsRoute
  '/_authenticated/audit-log': typeof AuthenticatedAuditLogRoute
  '/_authenticated/budget': typeof AuthenticatedBudgetRoute
  '/_authenticated/card': typeof AuthenticatedCardRoute
  '/_authenticated/companies': typeof AuthenticatedCompaniesRoute
  '/_authenticated/email-log': typeof AuthenticatedEmailLogRoute
  '/_authenticated/email-templates': typeof AuthenticatedEmailTemplatesRoute
  '/_authenticated/error-reports': typeof AuthenticatedErrorReportsRoute
  '/_authenticated/exports': typeof AuthenticatedExportsRoute
  '/_authenticated/imports': typeof AuthenticatedImportsRoute
  '/_authenticated/messages': typeof AuthenticatedMessagesRoute
  '/_authenticated/ov-cards': typeof AuthenticatedOvCardsRoute
  '/_authenticated/products': typeof AuthenticatedProductsRoute
  '/_authenticated/profile': typeof AuthenticatedProfileRoute
  '/_authenticated/shared-cards': typeof AuthenticatedSharedCardsRoute
  '/_authenticated/subscription': typeof AuthenticatedSubscriptionRoute
  '/_authenticated/subscriptions': typeof AuthenticatedSubscriptionsRoute
  '/_authenticated/transactions': typeof AuthenticatedTransactionsRoute
  '/_authenticated/brand-products': typeof AuthenticatedBrandProductsLazyRoute
  '/_authenticated/card-info': typeof AuthenticatedCardInfoLazyRoute
  '/_authenticated/changelog': typeof AuthenticatedChangelogLazyRoute
  '/_authenticated/customer-management': typeof AuthenticatedCustomerManagementLazyRoute
  '/_authenticated/dashboard-templates': typeof AuthenticatedDashboardTemplatesLazyRoute
  '/_authenticated/day-tickets': typeof AuthenticatedDayTicketsLazyRoute
  '/_authenticated/invoice-approvals': typeof AuthenticatedInvoiceApprovalsLazyRoute
  '/_authenticated/login-as': typeof AuthenticatedLoginAsLazyRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsLazyRoute
  '/_authenticated/subscription-types': typeof AuthenticatedSubscriptionTypesLazyRoute
  '/_authenticated/travel-costs': typeof AuthenticatedTravelCostsLazyRoute
  '/auth/callback': typeof AuthCallbackLazyRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/companies_/$companyId': typeof AuthenticatedCompaniesCompanyIdRouteRouteWithChildren
  '/_authenticated/dashboard-templates_/$templateId': typeof AuthenticatedDashboardTemplatesTemplateIdRoute
  '/_authenticated/email-templates_/$templateId': typeof AuthenticatedEmailTemplatesTemplateIdRoute
  '/_authenticated/imports_/$importId': typeof AuthenticatedImportsImportIdRoute
  '/_authenticated/imports_/new': typeof AuthenticatedImportsNewRoute
  '/_authenticated/my/e-tickets': typeof AuthenticatedMyETicketsRoute
  '/_authenticated/products_/$productId': typeof AuthenticatedProductsProductIdRoute
  '/_authenticated/approval/pending': typeof AuthenticatedApprovalPendingLazyRoute
  '/_authenticated/dashboard-templates_/new': typeof AuthenticatedDashboardTemplatesNewLazyRoute
  '/_authenticated/subscriptions_/export': typeof AuthenticatedSubscriptionsExportLazyRoute
  '/_authenticated/companies_/$companyId/anonymous-cards': typeof AuthenticatedCompaniesCompanyIdAnonymousCardsRoute
  '/_authenticated/companies_/$companyId/day-cards': typeof AuthenticatedCompaniesCompanyIdDayCardsRoute
  '/_authenticated/companies_/$companyId/e-tickets': typeof AuthenticatedCompaniesCompanyIdETicketsRoute
  '/_authenticated/companies_/$companyId/onboarding': typeof AuthenticatedCompaniesCompanyIdOnboardingRoute
  '/_authenticated/companies_/$companyId/personal-cards': typeof AuthenticatedCompaniesCompanyIdPersonalCardsRoute
  '/_authenticated/companies_/$companyId/users': typeof AuthenticatedCompaniesCompanyIdUsersRoute
  '/_authenticated/companies_/$companyId/admins': typeof AuthenticatedCompaniesCompanyIdAdminsLazyRoute
  '/_authenticated/companies_/$companyId/assign-cards': typeof AuthenticatedCompaniesCompanyIdAssignCardsLazyRoute
  '/_authenticated/companies_/$companyId/cost-centers': typeof AuthenticatedCompaniesCompanyIdCostCentersLazyRoute
  '/_authenticated/companies_/$companyId/custom-fields': typeof AuthenticatedCompaniesCompanyIdCustomFieldsLazyRoute
  '/_authenticated/companies_/$companyId/departments': typeof AuthenticatedCompaniesCompanyIdDepartmentsLazyRoute
  '/_authenticated/companies_/$companyId/details': typeof AuthenticatedCompaniesCompanyIdDetailsLazyRoute
  '/_authenticated/companies_/$companyId/distribution-points': typeof AuthenticatedCompaniesCompanyIdDistributionPointsLazyRoute
  '/_authenticated/companies_/$companyId/free-fields': typeof AuthenticatedCompaniesCompanyIdFreeFieldsLazyRoute
  '/_authenticated/companies_/$companyId/invoicing': typeof AuthenticatedCompaniesCompanyIdInvoicingLazyRoute
  '/_authenticated/companies_/$companyId/notifications': typeof AuthenticatedCompaniesCompanyIdNotificationsLazyRoute
  '/_authenticated/companies_/$companyId/project-codes': typeof AuthenticatedCompaniesCompanyIdProjectCodesLazyRoute
  '/_authenticated/companies_/$companyId/propositions': typeof AuthenticatedCompaniesCompanyIdPropositionsLazyRoute
  '/_authenticated/companies_/$companyId/repricing': typeof AuthenticatedCompaniesCompanyIdRepricingLazyRoute
  '/_authenticated/companies_/$companyId/settings': typeof AuthenticatedCompaniesCompanyIdSettingsLazyRoute
  '/_authenticated/companies_/$companyId/travellers': typeof AuthenticatedCompaniesCompanyIdTravellersLazyRoute
  '/_authenticated/my/e-tickets_/$eTicketId': typeof AuthenticatedMyETicketsETicketIdLazyRoute
  '/_authenticated/companies_/$companyId/': typeof AuthenticatedCompaniesCompanyIdIndexLazyRoute
  '/_authenticated/companies_/$companyId/users_/$userId': typeof AuthenticatedCompaniesCompanyIdUsersUserIdRouteRouteWithChildren
  '/_authenticated/companies_/$companyId/invoicing_/lines': typeof AuthenticatedCompaniesCompanyIdInvoicingLinesLazyRoute
  '/_authenticated/companies_/$companyId/users_/$userId/budget': typeof AuthenticatedCompaniesCompanyIdUsersUserIdBudgetRoute
  '/_authenticated/companies_/$companyId/users_/$userId/card': typeof AuthenticatedCompaniesCompanyIdUsersUserIdCardRoute
  '/_authenticated/companies_/$companyId/users_/$userId/messages': typeof AuthenticatedCompaniesCompanyIdUsersUserIdMessagesRoute
  '/_authenticated/companies_/$companyId/users_/$userId/profile': typeof AuthenticatedCompaniesCompanyIdUsersUserIdProfileRoute
  '/_authenticated/companies_/$companyId/users_/$userId/subscription': typeof AuthenticatedCompaniesCompanyIdUsersUserIdSubscriptionRoute
  '/_authenticated/companies_/$companyId/users_/$userId/subscriptions': typeof AuthenticatedCompaniesCompanyIdUsersUserIdSubscriptionsRoute
  '/_authenticated/companies_/$companyId/users_/$userId/transactions': typeof AuthenticatedCompaniesCompanyIdUsersUserIdTransactionsRoute
  '/_authenticated/companies_/$companyId/users_/$userId/settings': typeof AuthenticatedCompaniesCompanyIdUsersUserIdSettingsLazyRoute
  '/_authenticated/companies_/$companyId/users_/$userId/': typeof AuthenticatedCompaniesCompanyIdUsersUserIdIndexLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/uitnodiging-accepteren'
    | '/login'
    | '/all-products'
    | '/audit-log'
    | '/budget'
    | '/card'
    | '/companies'
    | '/email-log'
    | '/email-templates'
    | '/error-reports'
    | '/exports'
    | '/imports'
    | '/messages'
    | '/ov-cards'
    | '/products'
    | '/profile'
    | '/shared-cards'
    | '/subscription'
    | '/subscriptions'
    | '/transactions'
    | '/brand-products'
    | '/card-info'
    | '/changelog'
    | '/customer-management'
    | '/dashboard-templates'
    | '/day-tickets'
    | '/invoice-approvals'
    | '/login-as'
    | '/settings'
    | '/subscription-types'
    | '/travel-costs'
    | '/auth/callback'
    | '/companies/$companyId'
    | '/dashboard-templates/$templateId'
    | '/email-templates/$templateId'
    | '/imports/$importId'
    | '/imports/new'
    | '/my/e-tickets'
    | '/products/$productId'
    | '/approval/pending'
    | '/dashboard-templates/new'
    | '/subscriptions/export'
    | '/companies/$companyId/anonymous-cards'
    | '/companies/$companyId/day-cards'
    | '/companies/$companyId/e-tickets'
    | '/companies/$companyId/onboarding'
    | '/companies/$companyId/personal-cards'
    | '/companies/$companyId/users'
    | '/companies/$companyId/admins'
    | '/companies/$companyId/assign-cards'
    | '/companies/$companyId/cost-centers'
    | '/companies/$companyId/custom-fields'
    | '/companies/$companyId/departments'
    | '/companies/$companyId/details'
    | '/companies/$companyId/distribution-points'
    | '/companies/$companyId/free-fields'
    | '/companies/$companyId/invoicing'
    | '/companies/$companyId/notifications'
    | '/companies/$companyId/project-codes'
    | '/companies/$companyId/propositions'
    | '/companies/$companyId/repricing'
    | '/companies/$companyId/settings'
    | '/companies/$companyId/travellers'
    | '/my/e-tickets/$eTicketId'
    | '/companies/$companyId/'
    | '/companies/$companyId/users/$userId'
    | '/companies/$companyId/invoicing/lines'
    | '/companies/$companyId/users/$userId/budget'
    | '/companies/$companyId/users/$userId/card'
    | '/companies/$companyId/users/$userId/messages'
    | '/companies/$companyId/users/$userId/profile'
    | '/companies/$companyId/users/$userId/subscription'
    | '/companies/$companyId/users/$userId/subscriptions'
    | '/companies/$companyId/users/$userId/transactions'
    | '/companies/$companyId/users/$userId/settings'
    | '/companies/$companyId/users/$userId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/uitnodiging-accepteren'
    | '/login'
    | '/all-products'
    | '/audit-log'
    | '/budget'
    | '/card'
    | '/companies'
    | '/email-log'
    | '/email-templates'
    | '/error-reports'
    | '/exports'
    | '/imports'
    | '/messages'
    | '/ov-cards'
    | '/products'
    | '/profile'
    | '/shared-cards'
    | '/subscription'
    | '/subscriptions'
    | '/transactions'
    | '/brand-products'
    | '/card-info'
    | '/changelog'
    | '/customer-management'
    | '/dashboard-templates'
    | '/day-tickets'
    | '/invoice-approvals'
    | '/login-as'
    | '/settings'
    | '/subscription-types'
    | '/travel-costs'
    | '/auth/callback'
    | '/'
    | '/dashboard-templates/$templateId'
    | '/email-templates/$templateId'
    | '/imports/$importId'
    | '/imports/new'
    | '/my/e-tickets'
    | '/products/$productId'
    | '/approval/pending'
    | '/dashboard-templates/new'
    | '/subscriptions/export'
    | '/companies/$companyId/anonymous-cards'
    | '/companies/$companyId/day-cards'
    | '/companies/$companyId/e-tickets'
    | '/companies/$companyId/onboarding'
    | '/companies/$companyId/personal-cards'
    | '/companies/$companyId/users'
    | '/companies/$companyId/admins'
    | '/companies/$companyId/assign-cards'
    | '/companies/$companyId/cost-centers'
    | '/companies/$companyId/custom-fields'
    | '/companies/$companyId/departments'
    | '/companies/$companyId/details'
    | '/companies/$companyId/distribution-points'
    | '/companies/$companyId/free-fields'
    | '/companies/$companyId/invoicing'
    | '/companies/$companyId/notifications'
    | '/companies/$companyId/project-codes'
    | '/companies/$companyId/propositions'
    | '/companies/$companyId/repricing'
    | '/companies/$companyId/settings'
    | '/companies/$companyId/travellers'
    | '/my/e-tickets/$eTicketId'
    | '/companies/$companyId'
    | '/companies/$companyId/invoicing/lines'
    | '/companies/$companyId/users/$userId/budget'
    | '/companies/$companyId/users/$userId/card'
    | '/companies/$companyId/users/$userId/messages'
    | '/companies/$companyId/users/$userId/profile'
    | '/companies/$companyId/users/$userId/subscription'
    | '/companies/$companyId/users/$userId/subscriptions'
    | '/companies/$companyId/users/$userId/transactions'
    | '/companies/$companyId/users/$userId/settings'
    | '/companies/$companyId/users/$userId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/uitnodiging-accepteren'
    | '/login'
    | '/_authenticated/all-products'
    | '/_authenticated/audit-log'
    | '/_authenticated/budget'
    | '/_authenticated/card'
    | '/_authenticated/companies'
    | '/_authenticated/email-log'
    | '/_authenticated/email-templates'
    | '/_authenticated/error-reports'
    | '/_authenticated/exports'
    | '/_authenticated/imports'
    | '/_authenticated/messages'
    | '/_authenticated/ov-cards'
    | '/_authenticated/products'
    | '/_authenticated/profile'
    | '/_authenticated/shared-cards'
    | '/_authenticated/subscription'
    | '/_authenticated/subscriptions'
    | '/_authenticated/transactions'
    | '/_authenticated/brand-products'
    | '/_authenticated/card-info'
    | '/_authenticated/changelog'
    | '/_authenticated/customer-management'
    | '/_authenticated/dashboard-templates'
    | '/_authenticated/day-tickets'
    | '/_authenticated/invoice-approvals'
    | '/_authenticated/login-as'
    | '/_authenticated/settings'
    | '/_authenticated/subscription-types'
    | '/_authenticated/travel-costs'
    | '/auth/callback'
    | '/_authenticated/'
    | '/_authenticated/companies_/$companyId'
    | '/_authenticated/dashboard-templates_/$templateId'
    | '/_authenticated/email-templates_/$templateId'
    | '/_authenticated/imports_/$importId'
    | '/_authenticated/imports_/new'
    | '/_authenticated/my/e-tickets'
    | '/_authenticated/products_/$productId'
    | '/_authenticated/approval/pending'
    | '/_authenticated/dashboard-templates_/new'
    | '/_authenticated/subscriptions_/export'
    | '/_authenticated/companies_/$companyId/anonymous-cards'
    | '/_authenticated/companies_/$companyId/day-cards'
    | '/_authenticated/companies_/$companyId/e-tickets'
    | '/_authenticated/companies_/$companyId/onboarding'
    | '/_authenticated/companies_/$companyId/personal-cards'
    | '/_authenticated/companies_/$companyId/users'
    | '/_authenticated/companies_/$companyId/admins'
    | '/_authenticated/companies_/$companyId/assign-cards'
    | '/_authenticated/companies_/$companyId/cost-centers'
    | '/_authenticated/companies_/$companyId/custom-fields'
    | '/_authenticated/companies_/$companyId/departments'
    | '/_authenticated/companies_/$companyId/details'
    | '/_authenticated/companies_/$companyId/distribution-points'
    | '/_authenticated/companies_/$companyId/free-fields'
    | '/_authenticated/companies_/$companyId/invoicing'
    | '/_authenticated/companies_/$companyId/notifications'
    | '/_authenticated/companies_/$companyId/project-codes'
    | '/_authenticated/companies_/$companyId/propositions'
    | '/_authenticated/companies_/$companyId/repricing'
    | '/_authenticated/companies_/$companyId/settings'
    | '/_authenticated/companies_/$companyId/travellers'
    | '/_authenticated/my/e-tickets_/$eTicketId'
    | '/_authenticated/companies_/$companyId/'
    | '/_authenticated/companies_/$companyId/users_/$userId'
    | '/_authenticated/companies_/$companyId/invoicing_/lines'
    | '/_authenticated/companies_/$companyId/users_/$userId/budget'
    | '/_authenticated/companies_/$companyId/users_/$userId/card'
    | '/_authenticated/companies_/$companyId/users_/$userId/messages'
    | '/_authenticated/companies_/$companyId/users_/$userId/profile'
    | '/_authenticated/companies_/$companyId/users_/$userId/subscription'
    | '/_authenticated/companies_/$companyId/users_/$userId/subscriptions'
    | '/_authenticated/companies_/$companyId/users_/$userId/transactions'
    | '/_authenticated/companies_/$companyId/users_/$userId/settings'
    | '/_authenticated/companies_/$companyId/users_/$userId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  UitnodigingAccepterenRoute: typeof UitnodigingAccepterenRoute
  LoginLazyRoute: typeof LoginLazyRoute
  AuthCallbackLazyRoute: typeof AuthCallbackLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/uitnodiging-accepteren': {
      id: '/uitnodiging-accepteren'
      path: '/uitnodiging-accepteren'
      fullPath: '/uitnodiging-accepteren'
      preLoaderRoute: typeof UitnodigingAccepterenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/travel-costs': {
      id: '/_authenticated/travel-costs'
      path: '/travel-costs'
      fullPath: '/travel-costs'
      preLoaderRoute: typeof AuthenticatedTravelCostsLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/subscription-types': {
      id: '/_authenticated/subscription-types'
      path: '/subscription-types'
      fullPath: '/subscription-types'
      preLoaderRoute: typeof AuthenticatedSubscriptionTypesLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/login-as': {
      id: '/_authenticated/login-as'
      path: '/login-as'
      fullPath: '/login-as'
      preLoaderRoute: typeof AuthenticatedLoginAsLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/invoice-approvals': {
      id: '/_authenticated/invoice-approvals'
      path: '/invoice-approvals'
      fullPath: '/invoice-approvals'
      preLoaderRoute: typeof AuthenticatedInvoiceApprovalsLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/day-tickets': {
      id: '/_authenticated/day-tickets'
      path: '/day-tickets'
      fullPath: '/day-tickets'
      preLoaderRoute: typeof AuthenticatedDayTicketsLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard-templates': {
      id: '/_authenticated/dashboard-templates'
      path: '/dashboard-templates'
      fullPath: '/dashboard-templates'
      preLoaderRoute: typeof AuthenticatedDashboardTemplatesLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/customer-management': {
      id: '/_authenticated/customer-management'
      path: '/customer-management'
      fullPath: '/customer-management'
      preLoaderRoute: typeof AuthenticatedCustomerManagementLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/changelog': {
      id: '/_authenticated/changelog'
      path: '/changelog'
      fullPath: '/changelog'
      preLoaderRoute: typeof AuthenticatedChangelogLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/card-info': {
      id: '/_authenticated/card-info'
      path: '/card-info'
      fullPath: '/card-info'
      preLoaderRoute: typeof AuthenticatedCardInfoLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/brand-products': {
      id: '/_authenticated/brand-products'
      path: '/brand-products'
      fullPath: '/brand-products'
      preLoaderRoute: typeof AuthenticatedBrandProductsLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/transactions': {
      id: '/_authenticated/transactions'
      path: '/transactions'
      fullPath: '/transactions'
      preLoaderRoute: typeof AuthenticatedTransactionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/subscriptions': {
      id: '/_authenticated/subscriptions'
      path: '/subscriptions'
      fullPath: '/subscriptions'
      preLoaderRoute: typeof AuthenticatedSubscriptionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/subscription': {
      id: '/_authenticated/subscription'
      path: '/subscription'
      fullPath: '/subscription'
      preLoaderRoute: typeof AuthenticatedSubscriptionRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/shared-cards': {
      id: '/_authenticated/shared-cards'
      path: '/shared-cards'
      fullPath: '/shared-cards'
      preLoaderRoute: typeof AuthenticatedSharedCardsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile': {
      id: '/_authenticated/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthenticatedProfileRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/products': {
      id: '/_authenticated/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof AuthenticatedProductsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ov-cards': {
      id: '/_authenticated/ov-cards'
      path: '/ov-cards'
      fullPath: '/ov-cards'
      preLoaderRoute: typeof AuthenticatedOvCardsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/messages': {
      id: '/_authenticated/messages'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof AuthenticatedMessagesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/imports': {
      id: '/_authenticated/imports'
      path: '/imports'
      fullPath: '/imports'
      preLoaderRoute: typeof AuthenticatedImportsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/exports': {
      id: '/_authenticated/exports'
      path: '/exports'
      fullPath: '/exports'
      preLoaderRoute: typeof AuthenticatedExportsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/error-reports': {
      id: '/_authenticated/error-reports'
      path: '/error-reports'
      fullPath: '/error-reports'
      preLoaderRoute: typeof AuthenticatedErrorReportsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/email-templates': {
      id: '/_authenticated/email-templates'
      path: '/email-templates'
      fullPath: '/email-templates'
      preLoaderRoute: typeof AuthenticatedEmailTemplatesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/email-log': {
      id: '/_authenticated/email-log'
      path: '/email-log'
      fullPath: '/email-log'
      preLoaderRoute: typeof AuthenticatedEmailLogRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/companies': {
      id: '/_authenticated/companies'
      path: '/companies'
      fullPath: '/companies'
      preLoaderRoute: typeof AuthenticatedCompaniesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/card': {
      id: '/_authenticated/card'
      path: '/card'
      fullPath: '/card'
      preLoaderRoute: typeof AuthenticatedCardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/budget': {
      id: '/_authenticated/budget'
      path: '/budget'
      fullPath: '/budget'
      preLoaderRoute: typeof AuthenticatedBudgetRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/audit-log': {
      id: '/_authenticated/audit-log'
      path: '/audit-log'
      fullPath: '/audit-log'
      preLoaderRoute: typeof AuthenticatedAuditLogRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/all-products': {
      id: '/_authenticated/all-products'
      path: '/all-products'
      fullPath: '/all-products'
      preLoaderRoute: typeof AuthenticatedAllProductsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/subscriptions_/export': {
      id: '/_authenticated/subscriptions_/export'
      path: '/subscriptions/export'
      fullPath: '/subscriptions/export'
      preLoaderRoute: typeof AuthenticatedSubscriptionsExportLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard-templates_/new': {
      id: '/_authenticated/dashboard-templates_/new'
      path: '/dashboard-templates/new'
      fullPath: '/dashboard-templates/new'
      preLoaderRoute: typeof AuthenticatedDashboardTemplatesNewLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/approval/pending': {
      id: '/_authenticated/approval/pending'
      path: '/approval/pending'
      fullPath: '/approval/pending'
      preLoaderRoute: typeof AuthenticatedApprovalPendingLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/products_/$productId': {
      id: '/_authenticated/products_/$productId'
      path: '/products/$productId'
      fullPath: '/products/$productId'
      preLoaderRoute: typeof AuthenticatedProductsProductIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/my/e-tickets': {
      id: '/_authenticated/my/e-tickets'
      path: '/my/e-tickets'
      fullPath: '/my/e-tickets'
      preLoaderRoute: typeof AuthenticatedMyETicketsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/imports_/new': {
      id: '/_authenticated/imports_/new'
      path: '/imports/new'
      fullPath: '/imports/new'
      preLoaderRoute: typeof AuthenticatedImportsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/imports_/$importId': {
      id: '/_authenticated/imports_/$importId'
      path: '/imports/$importId'
      fullPath: '/imports/$importId'
      preLoaderRoute: typeof AuthenticatedImportsImportIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/email-templates_/$templateId': {
      id: '/_authenticated/email-templates_/$templateId'
      path: '/email-templates/$templateId'
      fullPath: '/email-templates/$templateId'
      preLoaderRoute: typeof AuthenticatedEmailTemplatesTemplateIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard-templates_/$templateId': {
      id: '/_authenticated/dashboard-templates_/$templateId'
      path: '/dashboard-templates/$templateId'
      fullPath: '/dashboard-templates/$templateId'
      preLoaderRoute: typeof AuthenticatedDashboardTemplatesTemplateIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/companies_/$companyId': {
      id: '/_authenticated/companies_/$companyId'
      path: '/companies/$companyId'
      fullPath: '/companies/$companyId'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/companies_/$companyId/': {
      id: '/_authenticated/companies_/$companyId/'
      path: '/'
      fullPath: '/companies/$companyId/'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdIndexLazyRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdRouteRoute
    }
    '/_authenticated/my/e-tickets_/$eTicketId': {
      id: '/_authenticated/my/e-tickets_/$eTicketId'
      path: '/my/e-tickets/$eTicketId'
      fullPath: '/my/e-tickets/$eTicketId'
      preLoaderRoute: typeof AuthenticatedMyETicketsETicketIdLazyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/companies_/$companyId/travellers': {
      id: '/_authenticated/companies_/$companyId/travellers'
      path: '/travellers'
      fullPath: '/companies/$companyId/travellers'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdTravellersLazyRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdRouteRoute
    }
    '/_authenticated/companies_/$companyId/settings': {
      id: '/_authenticated/companies_/$companyId/settings'
      path: '/settings'
      fullPath: '/companies/$companyId/settings'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdSettingsLazyRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdRouteRoute
    }
    '/_authenticated/companies_/$companyId/repricing': {
      id: '/_authenticated/companies_/$companyId/repricing'
      path: '/repricing'
      fullPath: '/companies/$companyId/repricing'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdRepricingLazyRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdRouteRoute
    }
    '/_authenticated/companies_/$companyId/propositions': {
      id: '/_authenticated/companies_/$companyId/propositions'
      path: '/propositions'
      fullPath: '/companies/$companyId/propositions'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdPropositionsLazyRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdRouteRoute
    }
    '/_authenticated/companies_/$companyId/project-codes': {
      id: '/_authenticated/companies_/$companyId/project-codes'
      path: '/project-codes'
      fullPath: '/companies/$companyId/project-codes'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdProjectCodesLazyRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdRouteRoute
    }
    '/_authenticated/companies_/$companyId/notifications': {
      id: '/_authenticated/companies_/$companyId/notifications'
      path: '/notifications'
      fullPath: '/companies/$companyId/notifications'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdNotificationsLazyRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdRouteRoute
    }
    '/_authenticated/companies_/$companyId/invoicing': {
      id: '/_authenticated/companies_/$companyId/invoicing'
      path: '/invoicing'
      fullPath: '/companies/$companyId/invoicing'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdInvoicingLazyRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdRouteRoute
    }
    '/_authenticated/companies_/$companyId/free-fields': {
      id: '/_authenticated/companies_/$companyId/free-fields'
      path: '/free-fields'
      fullPath: '/companies/$companyId/free-fields'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdFreeFieldsLazyRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdRouteRoute
    }
    '/_authenticated/companies_/$companyId/distribution-points': {
      id: '/_authenticated/companies_/$companyId/distribution-points'
      path: '/distribution-points'
      fullPath: '/companies/$companyId/distribution-points'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdDistributionPointsLazyRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdRouteRoute
    }
    '/_authenticated/companies_/$companyId/details': {
      id: '/_authenticated/companies_/$companyId/details'
      path: '/details'
      fullPath: '/companies/$companyId/details'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdDetailsLazyRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdRouteRoute
    }
    '/_authenticated/companies_/$companyId/departments': {
      id: '/_authenticated/companies_/$companyId/departments'
      path: '/departments'
      fullPath: '/companies/$companyId/departments'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdDepartmentsLazyRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdRouteRoute
    }
    '/_authenticated/companies_/$companyId/custom-fields': {
      id: '/_authenticated/companies_/$companyId/custom-fields'
      path: '/custom-fields'
      fullPath: '/companies/$companyId/custom-fields'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdCustomFieldsLazyRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdRouteRoute
    }
    '/_authenticated/companies_/$companyId/cost-centers': {
      id: '/_authenticated/companies_/$companyId/cost-centers'
      path: '/cost-centers'
      fullPath: '/companies/$companyId/cost-centers'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdCostCentersLazyRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdRouteRoute
    }
    '/_authenticated/companies_/$companyId/assign-cards': {
      id: '/_authenticated/companies_/$companyId/assign-cards'
      path: '/assign-cards'
      fullPath: '/companies/$companyId/assign-cards'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdAssignCardsLazyRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdRouteRoute
    }
    '/_authenticated/companies_/$companyId/admins': {
      id: '/_authenticated/companies_/$companyId/admins'
      path: '/admins'
      fullPath: '/companies/$companyId/admins'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdAdminsLazyRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdRouteRoute
    }
    '/_authenticated/companies_/$companyId/users': {
      id: '/_authenticated/companies_/$companyId/users'
      path: '/users'
      fullPath: '/companies/$companyId/users'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdUsersRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdRouteRoute
    }
    '/_authenticated/companies_/$companyId/personal-cards': {
      id: '/_authenticated/companies_/$companyId/personal-cards'
      path: '/personal-cards'
      fullPath: '/companies/$companyId/personal-cards'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdPersonalCardsRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdRouteRoute
    }
    '/_authenticated/companies_/$companyId/onboarding': {
      id: '/_authenticated/companies_/$companyId/onboarding'
      path: '/onboarding'
      fullPath: '/companies/$companyId/onboarding'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdOnboardingRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdRouteRoute
    }
    '/_authenticated/companies_/$companyId/e-tickets': {
      id: '/_authenticated/companies_/$companyId/e-tickets'
      path: '/e-tickets'
      fullPath: '/companies/$companyId/e-tickets'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdETicketsRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdRouteRoute
    }
    '/_authenticated/companies_/$companyId/day-cards': {
      id: '/_authenticated/companies_/$companyId/day-cards'
      path: '/day-cards'
      fullPath: '/companies/$companyId/day-cards'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdDayCardsRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdRouteRoute
    }
    '/_authenticated/companies_/$companyId/anonymous-cards': {
      id: '/_authenticated/companies_/$companyId/anonymous-cards'
      path: '/anonymous-cards'
      fullPath: '/companies/$companyId/anonymous-cards'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdAnonymousCardsRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdRouteRoute
    }
    '/_authenticated/companies_/$companyId/invoicing_/lines': {
      id: '/_authenticated/companies_/$companyId/invoicing_/lines'
      path: '/invoicing/lines'
      fullPath: '/companies/$companyId/invoicing/lines'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdInvoicingLinesLazyRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdRouteRoute
    }
    '/_authenticated/companies_/$companyId/users_/$userId': {
      id: '/_authenticated/companies_/$companyId/users_/$userId'
      path: '/users/$userId'
      fullPath: '/companies/$companyId/users/$userId'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdUsersUserIdRouteRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdRouteRoute
    }
    '/_authenticated/companies_/$companyId/users_/$userId/': {
      id: '/_authenticated/companies_/$companyId/users_/$userId/'
      path: '/'
      fullPath: '/companies/$companyId/users/$userId/'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdUsersUserIdIndexLazyRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdUsersUserIdRouteRoute
    }
    '/_authenticated/companies_/$companyId/users_/$userId/settings': {
      id: '/_authenticated/companies_/$companyId/users_/$userId/settings'
      path: '/settings'
      fullPath: '/companies/$companyId/users/$userId/settings'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdUsersUserIdSettingsLazyRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdUsersUserIdRouteRoute
    }
    '/_authenticated/companies_/$companyId/users_/$userId/transactions': {
      id: '/_authenticated/companies_/$companyId/users_/$userId/transactions'
      path: '/transactions'
      fullPath: '/companies/$companyId/users/$userId/transactions'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdUsersUserIdTransactionsRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdUsersUserIdRouteRoute
    }
    '/_authenticated/companies_/$companyId/users_/$userId/subscriptions': {
      id: '/_authenticated/companies_/$companyId/users_/$userId/subscriptions'
      path: '/subscriptions'
      fullPath: '/companies/$companyId/users/$userId/subscriptions'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdUsersUserIdSubscriptionsRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdUsersUserIdRouteRoute
    }
    '/_authenticated/companies_/$companyId/users_/$userId/subscription': {
      id: '/_authenticated/companies_/$companyId/users_/$userId/subscription'
      path: '/subscription'
      fullPath: '/companies/$companyId/users/$userId/subscription'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdUsersUserIdSubscriptionRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdUsersUserIdRouteRoute
    }
    '/_authenticated/companies_/$companyId/users_/$userId/profile': {
      id: '/_authenticated/companies_/$companyId/users_/$userId/profile'
      path: '/profile'
      fullPath: '/companies/$companyId/users/$userId/profile'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdUsersUserIdProfileRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdUsersUserIdRouteRoute
    }
    '/_authenticated/companies_/$companyId/users_/$userId/messages': {
      id: '/_authenticated/companies_/$companyId/users_/$userId/messages'
      path: '/messages'
      fullPath: '/companies/$companyId/users/$userId/messages'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdUsersUserIdMessagesRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdUsersUserIdRouteRoute
    }
    '/_authenticated/companies_/$companyId/users_/$userId/card': {
      id: '/_authenticated/companies_/$companyId/users_/$userId/card'
      path: '/card'
      fullPath: '/companies/$companyId/users/$userId/card'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdUsersUserIdCardRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdUsersUserIdRouteRoute
    }
    '/_authenticated/companies_/$companyId/users_/$userId/budget': {
      id: '/_authenticated/companies_/$companyId/users_/$userId/budget'
      path: '/budget'
      fullPath: '/companies/$companyId/users/$userId/budget'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdUsersUserIdBudgetRouteImport
      parentRoute: typeof AuthenticatedCompaniesCompanyIdUsersUserIdRouteRoute
    }
  }
}

interface AuthenticatedCompaniesCompanyIdUsersUserIdRouteRouteChildren {
  AuthenticatedCompaniesCompanyIdUsersUserIdBudgetRoute: typeof AuthenticatedCompaniesCompanyIdUsersUserIdBudgetRoute
  AuthenticatedCompaniesCompanyIdUsersUserIdCardRoute: typeof AuthenticatedCompaniesCompanyIdUsersUserIdCardRoute
  AuthenticatedCompaniesCompanyIdUsersUserIdMessagesRoute: typeof AuthenticatedCompaniesCompanyIdUsersUserIdMessagesRoute
  AuthenticatedCompaniesCompanyIdUsersUserIdProfileRoute: typeof AuthenticatedCompaniesCompanyIdUsersUserIdProfileRoute
  AuthenticatedCompaniesCompanyIdUsersUserIdSubscriptionRoute: typeof AuthenticatedCompaniesCompanyIdUsersUserIdSubscriptionRoute
  AuthenticatedCompaniesCompanyIdUsersUserIdSubscriptionsRoute: typeof AuthenticatedCompaniesCompanyIdUsersUserIdSubscriptionsRoute
  AuthenticatedCompaniesCompanyIdUsersUserIdTransactionsRoute: typeof AuthenticatedCompaniesCompanyIdUsersUserIdTransactionsRoute
  AuthenticatedCompaniesCompanyIdUsersUserIdSettingsLazyRoute: typeof AuthenticatedCompaniesCompanyIdUsersUserIdSettingsLazyRoute
  AuthenticatedCompaniesCompanyIdUsersUserIdIndexLazyRoute: typeof AuthenticatedCompaniesCompanyIdUsersUserIdIndexLazyRoute
}

const AuthenticatedCompaniesCompanyIdUsersUserIdRouteRouteChildren: AuthenticatedCompaniesCompanyIdUsersUserIdRouteRouteChildren =
  {
    AuthenticatedCompaniesCompanyIdUsersUserIdBudgetRoute:
      AuthenticatedCompaniesCompanyIdUsersUserIdBudgetRoute,
    AuthenticatedCompaniesCompanyIdUsersUserIdCardRoute:
      AuthenticatedCompaniesCompanyIdUsersUserIdCardRoute,
    AuthenticatedCompaniesCompanyIdUsersUserIdMessagesRoute:
      AuthenticatedCompaniesCompanyIdUsersUserIdMessagesRoute,
    AuthenticatedCompaniesCompanyIdUsersUserIdProfileRoute:
      AuthenticatedCompaniesCompanyIdUsersUserIdProfileRoute,
    AuthenticatedCompaniesCompanyIdUsersUserIdSubscriptionRoute:
      AuthenticatedCompaniesCompanyIdUsersUserIdSubscriptionRoute,
    AuthenticatedCompaniesCompanyIdUsersUserIdSubscriptionsRoute:
      AuthenticatedCompaniesCompanyIdUsersUserIdSubscriptionsRoute,
    AuthenticatedCompaniesCompanyIdUsersUserIdTransactionsRoute:
      AuthenticatedCompaniesCompanyIdUsersUserIdTransactionsRoute,
    AuthenticatedCompaniesCompanyIdUsersUserIdSettingsLazyRoute:
      AuthenticatedCompaniesCompanyIdUsersUserIdSettingsLazyRoute,
    AuthenticatedCompaniesCompanyIdUsersUserIdIndexLazyRoute:
      AuthenticatedCompaniesCompanyIdUsersUserIdIndexLazyRoute,
  }

const AuthenticatedCompaniesCompanyIdUsersUserIdRouteRouteWithChildren =
  AuthenticatedCompaniesCompanyIdUsersUserIdRouteRoute._addFileChildren(
    AuthenticatedCompaniesCompanyIdUsersUserIdRouteRouteChildren,
  )

interface AuthenticatedCompaniesCompanyIdRouteRouteChildren {
  AuthenticatedCompaniesCompanyIdAnonymousCardsRoute: typeof AuthenticatedCompaniesCompanyIdAnonymousCardsRoute
  AuthenticatedCompaniesCompanyIdDayCardsRoute: typeof AuthenticatedCompaniesCompanyIdDayCardsRoute
  AuthenticatedCompaniesCompanyIdETicketsRoute: typeof AuthenticatedCompaniesCompanyIdETicketsRoute
  AuthenticatedCompaniesCompanyIdOnboardingRoute: typeof AuthenticatedCompaniesCompanyIdOnboardingRoute
  AuthenticatedCompaniesCompanyIdPersonalCardsRoute: typeof AuthenticatedCompaniesCompanyIdPersonalCardsRoute
  AuthenticatedCompaniesCompanyIdUsersRoute: typeof AuthenticatedCompaniesCompanyIdUsersRoute
  AuthenticatedCompaniesCompanyIdAdminsLazyRoute: typeof AuthenticatedCompaniesCompanyIdAdminsLazyRoute
  AuthenticatedCompaniesCompanyIdAssignCardsLazyRoute: typeof AuthenticatedCompaniesCompanyIdAssignCardsLazyRoute
  AuthenticatedCompaniesCompanyIdCostCentersLazyRoute: typeof AuthenticatedCompaniesCompanyIdCostCentersLazyRoute
  AuthenticatedCompaniesCompanyIdCustomFieldsLazyRoute: typeof AuthenticatedCompaniesCompanyIdCustomFieldsLazyRoute
  AuthenticatedCompaniesCompanyIdDepartmentsLazyRoute: typeof AuthenticatedCompaniesCompanyIdDepartmentsLazyRoute
  AuthenticatedCompaniesCompanyIdDetailsLazyRoute: typeof AuthenticatedCompaniesCompanyIdDetailsLazyRoute
  AuthenticatedCompaniesCompanyIdDistributionPointsLazyRoute: typeof AuthenticatedCompaniesCompanyIdDistributionPointsLazyRoute
  AuthenticatedCompaniesCompanyIdFreeFieldsLazyRoute: typeof AuthenticatedCompaniesCompanyIdFreeFieldsLazyRoute
  AuthenticatedCompaniesCompanyIdInvoicingLazyRoute: typeof AuthenticatedCompaniesCompanyIdInvoicingLazyRoute
  AuthenticatedCompaniesCompanyIdNotificationsLazyRoute: typeof AuthenticatedCompaniesCompanyIdNotificationsLazyRoute
  AuthenticatedCompaniesCompanyIdProjectCodesLazyRoute: typeof AuthenticatedCompaniesCompanyIdProjectCodesLazyRoute
  AuthenticatedCompaniesCompanyIdPropositionsLazyRoute: typeof AuthenticatedCompaniesCompanyIdPropositionsLazyRoute
  AuthenticatedCompaniesCompanyIdRepricingLazyRoute: typeof AuthenticatedCompaniesCompanyIdRepricingLazyRoute
  AuthenticatedCompaniesCompanyIdSettingsLazyRoute: typeof AuthenticatedCompaniesCompanyIdSettingsLazyRoute
  AuthenticatedCompaniesCompanyIdTravellersLazyRoute: typeof AuthenticatedCompaniesCompanyIdTravellersLazyRoute
  AuthenticatedCompaniesCompanyIdIndexLazyRoute: typeof AuthenticatedCompaniesCompanyIdIndexLazyRoute
  AuthenticatedCompaniesCompanyIdUsersUserIdRouteRoute: typeof AuthenticatedCompaniesCompanyIdUsersUserIdRouteRouteWithChildren
  AuthenticatedCompaniesCompanyIdInvoicingLinesLazyRoute: typeof AuthenticatedCompaniesCompanyIdInvoicingLinesLazyRoute
}

const AuthenticatedCompaniesCompanyIdRouteRouteChildren: AuthenticatedCompaniesCompanyIdRouteRouteChildren =
  {
    AuthenticatedCompaniesCompanyIdAnonymousCardsRoute:
      AuthenticatedCompaniesCompanyIdAnonymousCardsRoute,
    AuthenticatedCompaniesCompanyIdDayCardsRoute:
      AuthenticatedCompaniesCompanyIdDayCardsRoute,
    AuthenticatedCompaniesCompanyIdETicketsRoute:
      AuthenticatedCompaniesCompanyIdETicketsRoute,
    AuthenticatedCompaniesCompanyIdOnboardingRoute:
      AuthenticatedCompaniesCompanyIdOnboardingRoute,
    AuthenticatedCompaniesCompanyIdPersonalCardsRoute:
      AuthenticatedCompaniesCompanyIdPersonalCardsRoute,
    AuthenticatedCompaniesCompanyIdUsersRoute:
      AuthenticatedCompaniesCompanyIdUsersRoute,
    AuthenticatedCompaniesCompanyIdAdminsLazyRoute:
      AuthenticatedCompaniesCompanyIdAdminsLazyRoute,
    AuthenticatedCompaniesCompanyIdAssignCardsLazyRoute:
      AuthenticatedCompaniesCompanyIdAssignCardsLazyRoute,
    AuthenticatedCompaniesCompanyIdCostCentersLazyRoute:
      AuthenticatedCompaniesCompanyIdCostCentersLazyRoute,
    AuthenticatedCompaniesCompanyIdCustomFieldsLazyRoute:
      AuthenticatedCompaniesCompanyIdCustomFieldsLazyRoute,
    AuthenticatedCompaniesCompanyIdDepartmentsLazyRoute:
      AuthenticatedCompaniesCompanyIdDepartmentsLazyRoute,
    AuthenticatedCompaniesCompanyIdDetailsLazyRoute:
      AuthenticatedCompaniesCompanyIdDetailsLazyRoute,
    AuthenticatedCompaniesCompanyIdDistributionPointsLazyRoute:
      AuthenticatedCompaniesCompanyIdDistributionPointsLazyRoute,
    AuthenticatedCompaniesCompanyIdFreeFieldsLazyRoute:
      AuthenticatedCompaniesCompanyIdFreeFieldsLazyRoute,
    AuthenticatedCompaniesCompanyIdInvoicingLazyRoute:
      AuthenticatedCompaniesCompanyIdInvoicingLazyRoute,
    AuthenticatedCompaniesCompanyIdNotificationsLazyRoute:
      AuthenticatedCompaniesCompanyIdNotificationsLazyRoute,
    AuthenticatedCompaniesCompanyIdProjectCodesLazyRoute:
      AuthenticatedCompaniesCompanyIdProjectCodesLazyRoute,
    AuthenticatedCompaniesCompanyIdPropositionsLazyRoute:
      AuthenticatedCompaniesCompanyIdPropositionsLazyRoute,
    AuthenticatedCompaniesCompanyIdRepricingLazyRoute:
      AuthenticatedCompaniesCompanyIdRepricingLazyRoute,
    AuthenticatedCompaniesCompanyIdSettingsLazyRoute:
      AuthenticatedCompaniesCompanyIdSettingsLazyRoute,
    AuthenticatedCompaniesCompanyIdTravellersLazyRoute:
      AuthenticatedCompaniesCompanyIdTravellersLazyRoute,
    AuthenticatedCompaniesCompanyIdIndexLazyRoute:
      AuthenticatedCompaniesCompanyIdIndexLazyRoute,
    AuthenticatedCompaniesCompanyIdUsersUserIdRouteRoute:
      AuthenticatedCompaniesCompanyIdUsersUserIdRouteRouteWithChildren,
    AuthenticatedCompaniesCompanyIdInvoicingLinesLazyRoute:
      AuthenticatedCompaniesCompanyIdInvoicingLinesLazyRoute,
  }

const AuthenticatedCompaniesCompanyIdRouteRouteWithChildren =
  AuthenticatedCompaniesCompanyIdRouteRoute._addFileChildren(
    AuthenticatedCompaniesCompanyIdRouteRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAllProductsRoute: typeof AuthenticatedAllProductsRoute
  AuthenticatedAuditLogRoute: typeof AuthenticatedAuditLogRoute
  AuthenticatedBudgetRoute: typeof AuthenticatedBudgetRoute
  AuthenticatedCardRoute: typeof AuthenticatedCardRoute
  AuthenticatedCompaniesRoute: typeof AuthenticatedCompaniesRoute
  AuthenticatedEmailLogRoute: typeof AuthenticatedEmailLogRoute
  AuthenticatedEmailTemplatesRoute: typeof AuthenticatedEmailTemplatesRoute
  AuthenticatedErrorReportsRoute: typeof AuthenticatedErrorReportsRoute
  AuthenticatedExportsRoute: typeof AuthenticatedExportsRoute
  AuthenticatedImportsRoute: typeof AuthenticatedImportsRoute
  AuthenticatedMessagesRoute: typeof AuthenticatedMessagesRoute
  AuthenticatedOvCardsRoute: typeof AuthenticatedOvCardsRoute
  AuthenticatedProductsRoute: typeof AuthenticatedProductsRoute
  AuthenticatedProfileRoute: typeof AuthenticatedProfileRoute
  AuthenticatedSharedCardsRoute: typeof AuthenticatedSharedCardsRoute
  AuthenticatedSubscriptionRoute: typeof AuthenticatedSubscriptionRoute
  AuthenticatedSubscriptionsRoute: typeof AuthenticatedSubscriptionsRoute
  AuthenticatedTransactionsRoute: typeof AuthenticatedTransactionsRoute
  AuthenticatedBrandProductsLazyRoute: typeof AuthenticatedBrandProductsLazyRoute
  AuthenticatedCardInfoLazyRoute: typeof AuthenticatedCardInfoLazyRoute
  AuthenticatedChangelogLazyRoute: typeof AuthenticatedChangelogLazyRoute
  AuthenticatedCustomerManagementLazyRoute: typeof AuthenticatedCustomerManagementLazyRoute
  AuthenticatedDashboardTemplatesLazyRoute: typeof AuthenticatedDashboardTemplatesLazyRoute
  AuthenticatedDayTicketsLazyRoute: typeof AuthenticatedDayTicketsLazyRoute
  AuthenticatedInvoiceApprovalsLazyRoute: typeof AuthenticatedInvoiceApprovalsLazyRoute
  AuthenticatedLoginAsLazyRoute: typeof AuthenticatedLoginAsLazyRoute
  AuthenticatedSettingsLazyRoute: typeof AuthenticatedSettingsLazyRoute
  AuthenticatedSubscriptionTypesLazyRoute: typeof AuthenticatedSubscriptionTypesLazyRoute
  AuthenticatedTravelCostsLazyRoute: typeof AuthenticatedTravelCostsLazyRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedCompaniesCompanyIdRouteRoute: typeof AuthenticatedCompaniesCompanyIdRouteRouteWithChildren
  AuthenticatedDashboardTemplatesTemplateIdRoute: typeof AuthenticatedDashboardTemplatesTemplateIdRoute
  AuthenticatedEmailTemplatesTemplateIdRoute: typeof AuthenticatedEmailTemplatesTemplateIdRoute
  AuthenticatedImportsImportIdRoute: typeof AuthenticatedImportsImportIdRoute
  AuthenticatedImportsNewRoute: typeof AuthenticatedImportsNewRoute
  AuthenticatedMyETicketsRoute: typeof AuthenticatedMyETicketsRoute
  AuthenticatedProductsProductIdRoute: typeof AuthenticatedProductsProductIdRoute
  AuthenticatedApprovalPendingLazyRoute: typeof AuthenticatedApprovalPendingLazyRoute
  AuthenticatedDashboardTemplatesNewLazyRoute: typeof AuthenticatedDashboardTemplatesNewLazyRoute
  AuthenticatedSubscriptionsExportLazyRoute: typeof AuthenticatedSubscriptionsExportLazyRoute
  AuthenticatedMyETicketsETicketIdLazyRoute: typeof AuthenticatedMyETicketsETicketIdLazyRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAllProductsRoute: AuthenticatedAllProductsRoute,
  AuthenticatedAuditLogRoute: AuthenticatedAuditLogRoute,
  AuthenticatedBudgetRoute: AuthenticatedBudgetRoute,
  AuthenticatedCardRoute: AuthenticatedCardRoute,
  AuthenticatedCompaniesRoute: AuthenticatedCompaniesRoute,
  AuthenticatedEmailLogRoute: AuthenticatedEmailLogRoute,
  AuthenticatedEmailTemplatesRoute: AuthenticatedEmailTemplatesRoute,
  AuthenticatedErrorReportsRoute: AuthenticatedErrorReportsRoute,
  AuthenticatedExportsRoute: AuthenticatedExportsRoute,
  AuthenticatedImportsRoute: AuthenticatedImportsRoute,
  AuthenticatedMessagesRoute: AuthenticatedMessagesRoute,
  AuthenticatedOvCardsRoute: AuthenticatedOvCardsRoute,
  AuthenticatedProductsRoute: AuthenticatedProductsRoute,
  AuthenticatedProfileRoute: AuthenticatedProfileRoute,
  AuthenticatedSharedCardsRoute: AuthenticatedSharedCardsRoute,
  AuthenticatedSubscriptionRoute: AuthenticatedSubscriptionRoute,
  AuthenticatedSubscriptionsRoute: AuthenticatedSubscriptionsRoute,
  AuthenticatedTransactionsRoute: AuthenticatedTransactionsRoute,
  AuthenticatedBrandProductsLazyRoute: AuthenticatedBrandProductsLazyRoute,
  AuthenticatedCardInfoLazyRoute: AuthenticatedCardInfoLazyRoute,
  AuthenticatedChangelogLazyRoute: AuthenticatedChangelogLazyRoute,
  AuthenticatedCustomerManagementLazyRoute:
    AuthenticatedCustomerManagementLazyRoute,
  AuthenticatedDashboardTemplatesLazyRoute:
    AuthenticatedDashboardTemplatesLazyRoute,
  AuthenticatedDayTicketsLazyRoute: AuthenticatedDayTicketsLazyRoute,
  AuthenticatedInvoiceApprovalsLazyRoute:
    AuthenticatedInvoiceApprovalsLazyRoute,
  AuthenticatedLoginAsLazyRoute: AuthenticatedLoginAsLazyRoute,
  AuthenticatedSettingsLazyRoute: AuthenticatedSettingsLazyRoute,
  AuthenticatedSubscriptionTypesLazyRoute:
    AuthenticatedSubscriptionTypesLazyRoute,
  AuthenticatedTravelCostsLazyRoute: AuthenticatedTravelCostsLazyRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedCompaniesCompanyIdRouteRoute:
    AuthenticatedCompaniesCompanyIdRouteRouteWithChildren,
  AuthenticatedDashboardTemplatesTemplateIdRoute:
    AuthenticatedDashboardTemplatesTemplateIdRoute,
  AuthenticatedEmailTemplatesTemplateIdRoute:
    AuthenticatedEmailTemplatesTemplateIdRoute,
  AuthenticatedImportsImportIdRoute: AuthenticatedImportsImportIdRoute,
  AuthenticatedImportsNewRoute: AuthenticatedImportsNewRoute,
  AuthenticatedMyETicketsRoute: AuthenticatedMyETicketsRoute,
  AuthenticatedProductsProductIdRoute: AuthenticatedProductsProductIdRoute,
  AuthenticatedApprovalPendingLazyRoute: AuthenticatedApprovalPendingLazyRoute,
  AuthenticatedDashboardTemplatesNewLazyRoute:
    AuthenticatedDashboardTemplatesNewLazyRoute,
  AuthenticatedSubscriptionsExportLazyRoute:
    AuthenticatedSubscriptionsExportLazyRoute,
  AuthenticatedMyETicketsETicketIdLazyRoute:
    AuthenticatedMyETicketsETicketIdLazyRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  UitnodigingAccepterenRoute: UitnodigingAccepterenRoute,
  LoginLazyRoute: LoginLazyRoute,
  AuthCallbackLazyRoute: AuthCallbackLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
